<template>
  <div>
    <div style="float: right" class="text-xs-right">
      <v-btn icon @click="$emit('close')"> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="pa-3 pt-1">
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <div
            style="position: relative; border: 1px solid grey; border-radius: 4px"
            class="showcarouselall"
          >
            <carousel
              :mouseDrag="false"
              :touchDrag="false"
              :pullDrag="false"
              v-if="ref_no_image.length"
              :items="1"
              :loop="true"
              :nav="false"
            >
              <div v-for="(item, k) in ref_no_image" :key="k" style="height: 360px; display: flex">
                <v-img @click="showImage(item, ref_no_image, k)" contain :src="item"></v-img>
              </div>

              <template slot="prev"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-left" /></v-btn
              ></template>
              <template slot="next"
                ><v-btn
                  v-show="ref_no_image.length > 1"
                  style="
                    z-index: 2;
                    position: absolute;
                    right: 0px;
                    top: 50%;
                    transform: translate(0%, -50%);
                  "
                  icon
                  small
                  color="primary"
                  ><em class="fas fa-chevron-right" /></v-btn
              ></template>
            </carousel>
          </div>
        </v-flex>
        <v-flex xs12 sm7>
          <div class="pa-2 pl-3">
            <div>
              <span style="color: grey">ชื่อลูกค้า : </span>
              {{ editdata.userdata.firstName + ' ' + editdata.userdata.lastName }}
              <div
                class="mt-2 form-control"
                style="display: flex"
                :class="{ 'has-error': errors.has('ร้าน') }"
              >
                <div style="align-self: center" class="mr-4 pb-2">ชื่อร้าน:&nbsp;&nbsp;</div>
                <div v-if="readonly">{{ input.store || '-' }}</div>
                <div v-else style="width: 70%">
                  <multiselect
                    :data-vv-as="$t('ร้าน')"
                    v-validate="'required'"
                    :show-labels="false"
                    name="ร้าน"
                    :options="storeOptions"
                    v-model="input.store"
                    @input="onSelectedStore($event)"
                  >
                    <template v-slot:noResult> ไม่พบข้อมูล </template>
                  </multiselect>
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('ร้าน') }">
                <span class="text-error" v-if="errors.has('ร้าน')">{{ errors.first('ร้าน') }}</span>
              </div>
              <div
                class="mt-2"
                :class="{ 'has-error': errors.has('รหัสร้าน') }"
                style="display: flex"
              >
                <div style="align-self: center" class="mr-4 pb-2">รหัสร้าน:</div>
                <div v-if="readonly">{{ input.store_id || '-' }}</div>
                <div v-else style="width: 70%" class="form-control">
                  <input
                    readonly
                    :data-vv-as="$t('รหัสร้าน')"
                    v-validate="'required'"
                    :name="'รหัสร้าน'"
                    v-model="input.store_id"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div :class="{ 'has-error form-control': errors.has('รหัสร้าน') }">
                <span class="text-error" v-if="errors.has('รหัสร้าน')">{{
                  errors.first('รหัสร้าน')
                }}</span>
              </div>
            </div>
          </div>
          <div>
            <v-divider class="my-3"></v-divider>
          </div>
          <div class="pl-3">
            <v-layout row wrap>
              <v-flex xs3> <div class="pt-3">เลขที่ใบเสร็จ :</div></v-flex>
              <v-flex xs9>
                <div class="pt-3" v-if="readonly">{{ input.ref_no || '-' }}</div>
                <div
                  v-else
                  class="form-control pa-1"
                  style="position: relative"
                  :class="{ 'has-error': errors.has('เลขที่ใบเสร็จ'), 'is-valid': isRefnoValid }"
                >
                  <input
                    @input="isRefnoValid = false"
                    placeholder="กรอกเลขที่ใบเสร็จ"
                    :data-vv-as="$t('เลขที่ใบเสร็จ')"
                    v-validate="'required'"
                    name="เลขที่ใบเสร็จ"
                    v-model="input.ref_no"
                    class="form-control mb-0"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('เลขที่ใบเสร็จ')">{{
                    errors.first('เลขที่ใบเสร็จ')
                  }}</span>
                  <div class="text-xs-right">
                    <v-btn
                      @click="checkAvailableRef"
                      :loading="checkRefLoading"
                      :disabled="checkAvailableRefButton"
                      color="primary"
                      >ตรวจสอบ</v-btn
                    >
                  </div>
                </div>
              </v-flex>

              <v-flex xs3 class="pt-3">วันที่ในเอกสาร :</v-flex>
              <v-flex xs9>
                <div class="pt-3" v-if="readonly">{{ input.date | DateFormat('DD/MM/YYYY') }}</div>
                <div
                  v-else
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('วันที่ในเอกสาร') }"
                >
                  <DatePickerWithoutButton @input="errors.clear()" v-model="input.date">
                    <input
                      readonly
                      placeholder="กรอกวันที่ในเอกสาร"
                      :data-vv-as="$t('วันที่ในเอกสาร')"
                      v-validate="'required'"
                      name="วันที่ในเอกสาร"
                      :value="getDate(input.date)"
                      class="form-control"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                  <div :class="{ 'has-error form-control': errors.has('วันที่ในเอกสาร') }">
                    <span class="text-error" v-if="errors.has('วันที่ในเอกสาร')">{{
                      errors.first('วันที่ในเอกสาร')
                    }}</span>
                  </div>
                </div></v-flex
              >
            </v-layout>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
      <div>
        <div class="my-3 px-3">
          <div style="font-weight: 600; font-size: 19px">
            {{ readonly ? '' : 'กรอก' }}ข้อมูลสินค้า
          </div>
        </div>
        <div>
          <v-layout row wrap>
            <v-flex xs6>
              <div class="text-center">ชื่อสินค้า</div>
            </v-flex>
            <v-flex xs1 v-if="campaignType != 'lucky_draw'">
              <div class="text-center">แต้มพิเศษ</div></v-flex
            >
            <v-flex xs1> <div class="text-center">จำนวน</div></v-flex>
            <v-flex xs1> <div class="text-center">ราคา</div></v-flex>
            <v-flex xs2> <div class="text-center">รวมเงิน</div></v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs12 class="pa-0 ma-0 pt-1">
              <div class="pa-2">
                <div v-for="(item, k) in products" :key="k">
                  <v-layout class="ma-0 pa-0">
                    <v-flex style="margin-bottom: 7px; align-self: center" xs6>
                      <div v-if="readonly">
                        {{ item.name.product_name_en }}, {{ item.name.product_name_th }},
                        {{ item.name.product_size }}
                      </div>
                      <div
                        v-else
                        class="default-input px-1"
                        :class="{ 'has-error': errors.has('สินค้า' + k) }"
                      >
                        <multiselect
                          class="toa-product"
                          :ref="'productInput' + k"
                          @input="onChangeProduct(k, $event)"
                          :option-height="104"
                          v-model="item.name"
                          placeholder="สินค้า"
                          :show-labels="false"
                          label="ชื่อสินค้า"
                          :options="allproducts"
                          :name="'สินค้า' + k"
                          :key="'สินค้า' + k"
                          :data-vv-as="$t('สินค้า')"
                          v-validate="approvetype != 'reject' ? 'required' : ''"
                          preserveSearch
                          :loading="isLoadingProduct"
                          :customLabel="customMaterialName"
                        >
                          <!-- @search-change="onSearchProduct"
                          :internal-search="false" -->
                          <!-- <template slot="singleLabel" slot-scope="props">
                            <div
                              class="option__desc"
                              v-html="customMaterialName(props.option)"
                            ></div>
                          </template>
                          <template slot="option" slot-scope="props">
                            <div
                              class="option__desc"
                              v-html="customMaterialName(props.option)"
                            ></div>
                          </template> -->
                          <template v-slot:noResult> ไม่พบข้อมูล </template>
                        </multiselect>
                        <span class="text-error" v-if="errors.has('สินค้า' + k)">{{
                          errors.first('สินค้า' + k)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex
                      style="align-self: center"
                      xs1
                      class="form-control"
                      v-if="campaignType != 'lucky_draw'"
                    >
                      <div class="text-xs-center">
                        {{ item.score ? numberFormat(item.score) : 0 }}
                      </div>
                    </v-flex>
                    <v-flex style="align-self: center" xs1 class="form-control">
                      <div class="text-xs-center" v-if="readonly">
                        {{ numberFormat(item.quantity) }}
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('จำนวน' + k) }"
                      >
                        <input
                          @blur="!item.quantity || item.quantity == 0 ? (item.quantity = 1) : ''"
                          @keyup.enter="addmoreproduct"
                          @change="changePrice(item)"
                          placeholder="จำนวน"
                          :data-vv-as="$t('จำนวน')"
                          v-validate="'required'"
                          :name="'จำนวน' + k"
                          v-model="item.quantity"
                          class="form-control"
                          type="text"
                          @keypress="keyIsNumber"
                        />
                        <span class="text-error" v-if="errors.has('จำนวน' + k)">
                          {{ errors.first('จำนวน' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex style="align-self: center" xs1 class="form-control">
                      <div class="text-xs-center">
                        {{ numberFormat(item.price) }}
                      </div>
                      <!-- <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('ราคา' + k) }"
                      >
                        <input
                          @blur="!item.price ? (item.price = 0) : ''"
                          @keyup.enter="addmoreproduct"
                          placeholder="ราคา"
                          :data-vv-as="$t('ราคา')"
                          v-validate="'required'"
                          :name="'ราคา' + k"
                          min="0"
                          v-model="item.price"
                          class="form-control"
                          type="number"
                        />
                        <span class="text-error" v-if="errors.has('ราคา' + k)">
                          {{ errors.first('ราคา' + k) }}
                        </span>
                      </div> -->
                    </v-flex>
                    <v-flex xs2 style="align-self: center">
                      <div style="font-size: 17px" class="text-xs-center" v-if="readonly">
                        <template v-if="item.total">
                          {{ item.total }}
                        </template>
                        <span v-else>
                          {{ numberFormat(item.quantity * item.price) }}
                        </span>
                      </div>
                      <div
                        v-else
                        class="form-control px-1"
                        :class="{ 'has-error': errors.has('รวมเงิน' + k) }"
                      >
                        <!-- 
                          @blur="!item.price ? (item.price = 0) : ''"
                          @keyup.enter="addmoreproduct" -->
                        <input
                          placeholder="รวมเงิน"
                          @keyup.enter="addmoreproduct"
                          @change="changePrice(item)"
                          :data-vv-as="$t('รวมเงิน')"
                          v-validate="'required'"
                          :name="'รวมเงิน' + k"
                          min="0"
                          v-model="item.total"
                          class="form-control"
                          type="text"
                          @keypress="keyIsNumber"
                        />
                        <span class="text-error" v-if="errors.has('รวมเงิน' + k)">
                          {{ errors.first('รวมเงิน' + k) }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex
                      style="align-self: center; white-space: nowrap"
                      v-if="!readonly"
                      xs1
                      class="text-xs-right"
                    >
                      <v-btn class="mx-0 mr-1" small @click="copyProducts(item)" icon>
                        <v-icon color="primary">file_copy</v-icon>
                      </v-btn>
                      <v-btn class="mx-0" small tabindex="-1" @click="deleteProducts(k)" icon>
                        <v-icon color="primary">delete</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
                <v-divider class="my-2"></v-divider>
              </div>
              <div v-if="!readonly && campaignType != 'lucky_draw'" class="text-xs-right">
                <v-btn @click="addmoreproduct" flat color="primary"
                  ><em class="mr-2 fas fa-plus" /> เพิ่มสินค้า</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="px-3">
        <v-layout row wrap>
          <v-flex xs12>
            <div style="font-size: 30px"><strong>สรุป</strong></div>
            <div>
              <span>รายการสินค้า</span>
              <span class="primary--text text--weight-bold" style="font-weight: bold">
                {{ products.length }}</span
              >
              รายการ
            </div>
            <div>
              <span>จำนวนทั้งหมด</span>
              <span class="primary--text text--weight-bold" style="font-weight: bold">
                {{ numberFormat(sumquantity) }}
              </span>
              ชิ้น
            </div>
            <div class="mt-2 mb-2">
              <v-checkbox
                :readonly="readonly"
                v-model="includeVat"
                label="VAT 7%"
                color="primary"
              ></v-checkbox>
            </div>
            <div style="font-size: 18px"><strong>ส่วนลด</strong></div>
            <v-layout row class="mt-2 mb-2">
              <v-flex xs6 sm3 class="form-control pa-1">
                <input
                  :disabled="readonly"
                  type="text"
                  placeholder="ส่วนลด"
                  v-model="discount"
                  class="form-control col-8"
                  maxlength="255"
                  @keypress="keyIsNumber"
                />
              </v-flex>
              <div style="align-items: center" class="d-flex">บาท</div>
            </v-layout>

            <div v-if="campaignType == 'full'">
              <span style="font-size: 25px">จำนวนคูปอง</span>
              <span style="font-size: 25px" class="primary--text font-weight-bold">{{
                numberFormat(sumcoupon)
              }}</span
              >&nbsp;<span style="font-size: 25px">ใบ</span>
            </div>
            <div>
              <span style="font-size: 25px">ยอดซื้อรวม</span>
              <span style="font-size: 25px" class="primary--text font-weight-bold">{{
                numberFormat(sumprice)
              }}</span
              >&nbsp;<span style="font-size: 25px">บาท</span>
            </div>
            <br />
            <div v-if="campaignType == 'collect'">
              <div style="font-size: 30px"><strong>สรุปแต้ม</strong></div>
              <div>
                <span style="font-size: 18px">แต้มจากยอดซื้อ</span>
                <span style="font-size: 18px" class="primary--text font-weight-bold">{{
                  numberFormat(sumScoreCollect)
                }}</span
                >&nbsp;<span style="font-size: 18px">แต้ม</span>
              </div>

              <div>
                <span style="font-size: 18px">แต้มพิเศษ</span>
                <span style="font-size: 18px" class="primary--text font-weight-bold">{{
                  numberFormat(sumSpacialPrice)
                }}</span
                >&nbsp;<span style="font-size: 18px">แต้ม</span>
              </div>

              <div>
                <span style="font-size: 18px">แต้มรวม</span>
                <span style="font-size: 18px" class="primary--text font-weight-bold">{{
                  numberFormat(sumAllCollectScore)
                }}</span
                >&nbsp;<span style="font-size: 18px">แต้ม</span>
              </div>
            </div>

            <div v-if="campaignType == 'lucky_draw'">
              <div>
                <span style="font-size: 18px">จำนวนสิทธิ์ที่ได้</span>
                <span style="font-size: 18px" class="primary--text font-weight-bold">{{
                  numberFormat(sumPrivilege)
                }}</span
                >&nbsp;<span style="font-size: 18px">สิทธิ์</span>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="text-xs-left px-3">
        <div class="form-control text-xs-left" :class="{ 'has-error': errors.has('สถานะใบเสร็จ') }">
          <v-radio-group
            :readonly="readonly"
            :error-messages="!approvetype ? errors.first('สถานะใบเสร็จ') : ''"
            class="mb-0 pb-0"
            name="สถานะใบเสร็จ"
            v-validate="'required'"
            data-vv-as="สถานะใบเสร็จ"
            data-vv-name="สถานะใบเสร็จ"
            key="สถานะใบเสร็จ"
            row
            v-model="approvetype"
          >
            <v-radio color="green" value="approved">
              <template v-slot:label>
                <span class="green--text">Approve</span>
              </template>
            </v-radio>
            <v-radio color="red" value="reject">
              <template v-slot:label>
                <span class="red--text">Reject</span>
              </template></v-radio
            >
            <v-radio color="#EDBA36" value="waiting_for_delivery">
              <template v-slot:label>
                <span class="brown--text">รอตรวจสอบ</span>
              </template>
            </v-radio>
          </v-radio-group>
          <!-- <div>
            <span class="text-error" v-if="errors.has('Approve / Reject / รอการจัดส่ง')">
              {{ errors.first('Approve / Reject / รอการจัดส่ง') }}
            </span>
          </div> -->
        </div>
      </div>

      <div v-if="approvetype == 'approved'">
        <div v-if="campaignType != 'collect'">
          <div v-for="(item, k) in coupon" :key="k">
            <div>
              <span>www.xxxxxx.com/ecoupon?barcode=[</span>
              <span>
                <input
                  style="width: 150px"
                  placeholder="กรอกรหัสบาร์โค้ด"
                  :data-vv-as="$t('กรอกรหัสบาร์โค้ด')"
                  v-validate="'required|barcode_format'"
                  :name="'barcode' + k"
                  v-model="item.barcode"
                  class="form-control"
                  type="text"
                />
              </span>
              <span>]&amount=</span>
              <span>
                <input
                  @blur="!item.amount ? (item.amount = 0) : ''"
                  style="width: 150px"
                  placeholder="กรอกมูลค่า E-Coupon เช่น 100"
                  :data-vv-as="$t('กรอกมูลค่า E-Coupon เช่น 100')"
                  v-validate="'required|morethan0'"
                  :name="'amount' + k"
                  v-model="item.amount"
                  class="form-control"
                  type="text"
                  @keypress="keyIsNumber"
                />
              </span>
              <span>
                <v-btn tabindex="-1" @click="deleteCoupon(k)" icon v-if="!readonly">
                  <v-icon color="primary">delete</v-icon></v-btn
                >
              </span>
              <div style="display: flex; justify-content: space-between">
                <div :class="{ 'has-error form-control': errors.has('barcode' + k), 'mr-1': true }">
                  <span class="text-error" v-if="errors.has('barcode' + k)">{{
                    errors.first('barcode' + k)
                  }}</span>
                </div>
                <div :class="{ 'has-error form-control': errors.has('amount' + k) }">
                  <span class="text-error" v-if="errors.has('amount' + k)">{{
                    errors.first('amount' + k)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-xs-right" v-if="campaignType != 'lucky_draw'">
            <v-btn @click="addmorecoupon" flat color="primary" v-if="!readonly"
              ><em class="mr-2 fas fa-plus" /> เพิ่มคูปอง</v-btn
            >
          </div>
        </div>
      </div>
      <div v-if="approvetype == 'reject' && !readonly">
        <multiselect
          v-model="rejectReason"
          :data-vv-as="$t('สาเหตุที่ Reject')"
          v-validate="'required'"
          :name="'select-reason'"
          placeholder="เลือกเหตุผล"
          :show-labels="false"
          :options="rejectOptions"
          :searchable="false"
        >
          <template v-slot:noResult> ไม่พบข้อมูล </template>
        </multiselect>
        <span class="text-error red--text" v-if="errors.has('select-reason')">
          {{ errors.first('select-reason') }}
        </span>
        <div
          v-if="rejectReason == 'อื่น ๆ โปรดระบุ..'"
          class="form-control text-xs-left mt-2"
          :class="{ 'has-error': errors.has('remark') }"
        >
          <input
            style="width: 50%"
            placeholder="กรอกสาเหตุที่ Reject"
            :data-vv-as="$t('สาเหตุที่ Reject')"
            v-validate="'required'"
            :name="'remark'"
            v-model="input.remark"
            class="form-control"
            type="text"
          />
          <span class="text-error" v-if="errors.has('remark')">
            {{ errors.first('remark') }}
          </span>
        </div>
      </div>
      <div class="text-xs-center mt-2" v-if="!readonly">
        <v-btn @click="saveData" :loading="saveloading" depressed color="primary">ยืนยัน</v-btn>
        <v-btn @click="$emit('close')" color="grey" outline>ยกเลิก</v-btn>
      </div>
    </div>
    <v-dialog v-model="showImageDialog" width="550px" persistent>
      <v-card v-if="showImageDialog">
        <div class="text-xs-right">
          <v-btn @click="showImageDialog = false" icon> <v-icon>close</v-icon></v-btn>
        </div>
        <img style="object-fit: contain; width: 100%" :src="currentShowImage" />
        <div class="pa-3"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import Multiselect from 'vue-multiselect'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
import CurrencyInput from '@/components/elements/CurrencyInput.vue'
import PhotoViewer from 'photoviewer'
import { Validator } from 'vee-validate'
Validator.extend('barcode_format', {
  validate: (value) => {
    let result = value.length == 22
    return result
  },
  getMessage: (field) => 'บาร์โค้ดต้องครบ 22 หลัก'
})

Validator.extend('dup_barcode', {
  validate: (value, options) => {
    console.log(options)
    return true
  },
  getMessage: (field) => 'gg ez'
})
Validator.extend('morethan0', {
  validate: (value) => {
    let result = value > 0
    return result
  },
  getMessage: (field) => 'จำนวนเงินต้องมากกว่า 0'
})

export default {
  components: {
    carousel,
    Multiselect,
    DatePickerWithoutButton,
    CurrencyInput
  },
  props: ['editdata', 'alldata'],
  data() {
    return {
      readonly: false,
      checkRefLoading: false,
      isRefnoValid: false,
      excludedrefno: '',
      excludedsku: '',
      currentShowImage: '',
      showImageDialog: false,
      ref_no_image: [],
      saveloading: false,
      approvetype: null,
      discount: null,
      input: {
        store_name: '',
        store_id: '',
        ref_no: '',
        date: '',
        remark: ''
      },
      products: [
        {
          name: '',
          price: 0,
          quantity: 0,
          total: 0,
          score: 0
        }
      ],
      coupon: [],
      duplicateReceiptId: null,
      rejectOptions: [
        'ยอดซื้อสินค้า ทีโอเอ ไม่ครบ ตามที่เงื่อนไขบริษัทฯ กำหนด',
        'รูปภาพบิลใบเสร็จไม่ชัดเจน กรุณาแนบมาใหม่อีกครั้ง',
        'ร้านค้าดังกล่าวไม่ได้เข้าร่วมรายการ กรุณาตรวจสอบรายชื่อร้านค้าที่เข้าร่วมรายการใหม่',
        'บิลใบเสร็จไม่ตรงตามเงื่อนไข ไม่สามารถเข้าร่วมรายการได้',
        'กรุณาแนบรูป 1 บิลใบเสร็จ ต่อ 1 เลขใบเสร็จ',
        'สำเนาใบกำกับภาษี/ใบเสร็จรับเงินที่ส่งมา ถูกใช้งานแล้ว',
        'กรุณาแนบรูปถ่ายมาคู่กับสินค้าที่ซื้อ',
        'อื่น ๆ โปรดระบุ..'
      ],
      rejectReason: '',
      includeVat: false,
      campaignType: '',
      campaign_id: null,
      searchProduct: '',
      isLoadingProduct: false
    }
  },
  computed: {
    checkAvailableRefButton() {
      return (
        ['approved', 'reject'].includes(this.editdata.status) ||
        !this.input.store_id ||
        !this.input.ref_no ||
        this.input.ref_no == '-'
      )
    },
    ...mapGetters(['selectedBot']),
    sumquantity() {
      return Math.floor(
        this.products.reduce((acc, cur) => {
          return acc + parseFloat(cur.quantity || 0)
        }, 0)
      )
    },
    sumprice() {
      let sumPrice = Math.floor(
        parseFloat(
          this.products.reduce((acc, cur) => {
            let total = cur.total
              ? parseFloat(cur.total)
              : parseFloat(cur.price || 0) * parseFloat(cur.quantity)
            return acc + total
          }, 0)
        )
      )

      // Check it's including with vat
      if (
        this.includeVat ||
        (this.editdata.detail &&
          this.editdata.detail.hasOwnProperty('include_vat') &&
          this.editdata.detail.include_vat)
      ) {
        // vat 7% from 7/100 to 0.07
        // sumPrice = (sumPrice + sumPrice * 0.07).toFixed(2)
        sumPrice = Math.ceil(sumPrice + sumPrice * 0.07)
      }

      if (this.discount) {
        sumPrice = sumPrice - this.discount
      }

      if (sumPrice < 0) {
        return 0
      }

      // Affected to coupon amount
      // 5000 Bath per 1 coupon
      // if (sumPrice > 0) {
      //   let coupon_amount = Math.floor(sumPrice / 5000)
      //   if (coupon_amount > 0) {
      //     if (this.coupon.length < coupon_amount) {
      //       let left = coupon_amount - this.coupon.length
      //       for (var i = 0; i < left; i++) {
      //         this.coupon.push({
      //           barcode: '',
      //           amount: 0
      //         })
      //       }
      //     } else {
      //       let left = this.coupon.length - coupon_amount
      //       for (var i = 0; i < left; i++) {
      //         this.coupon.pop()
      //       }
      //     }
      //   }
      // }

      return sumPrice
    },
    sumcoupon() {
      return this.coupon.length
    },
    sumScoreCollect() {
      let score = 0
      if (this.editdata.campaign_type == 'collect') {
        score = (this.sumprice * this.editdata.campaign_collect_score).toFixed(2)
      }
      return parseFloat(score)
    },
    sumSpacialPrice() {
      let sumPrice = Math.floor(
        parseFloat(
          this.products.reduce((acc, cur) => {
            return acc + (cur.score ? parseFloat(cur.score || 0) : 0) * cur.quantity
          }, 0)
        )
      )
      return sumPrice
    },
    sumAllCollectScore() {
      return this.sumScoreCollect + this.sumSpacialPrice
    },
    points_by_purchase() {
      var result = 0
      var sum = this.products.reduce((acc, cur) => {
        let total = cur.total
          ? parseFloat(cur.total)
          : parseFloat(cur.price || 0) * parseFloat(cur.quantity || 0)
        return acc + total
      }, 0)
      result = sum / this.purchase_amount
      return Math.floor(result)
    },
    points_by_product() {
      var result
      result = this.products.reduce((acc, cur) => {
        return (
          acc + (cur.name ? parseFloat(cur.name.points || 0) : 0) * parseFloat(cur.quantity || 0)
        )
      }, 0)
      return Math.floor(result)
    },
    purchase_amount() {
      if (this.$store.state.toacrmpointdata && this.$store.state.toacrmpointdata.purchase_amount) {
        return Math.floor(parseFloat(this.$store.state.toacrmpointdata.purchase_amount))
      } else return 0
    },
    allproducts() {
      var products = [...new Set(this.$store.state.toaEcouponProducts)]
      if (this.searchProduct) {
        products = products.filter(
          (el) =>
            (el.product_name_en &&
              el.product_name_en.toLowerCase().includes(this.searchProduct.toLowerCase())) ||
            (el.product_name_th &&
              el.product_name_th.toLowerCase().includes(this.searchProduct.toLowerCase())) ||
            (el.product_size &&
              el.product_size.toLowerCase().includes(this.searchProduct.toLowerCase()))
        )
      }
      return products
    },
    storeOptions() {
      var stores = [...new Set(this.$store.state.toaEcouponStore.map((el) => el.store_name))]
      return stores
    },
    sumPrivilege() {
      let price = this.sumprice || 0
      if (price == 0) return 0

      if (this.editdata.is_purchase_amount) {
        return Math.floor(price / parseFloat(this.editdata.purchase_amount))
      } else if (this.editdata.is_min_purchase_amount) {
        if (price >= parseFloat(this.editdata.min_purchase_amount))
          return parseFloat(this.editdata.privilege_amount)
      }
      return 0
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    try {
      const attachments = JSON.parse(this.editdata.attachment)
      this.ref_no_image = attachments ? attachments.filter((attachment) => attachment) : []
    } catch (error) {
      console.error(error)
      this.ref_no_image = []
    }

    if (['approved', 'reject'].includes(this.editdata.status)) {
      this.readonly = true
      this.approvetype = this.editdata.status
    }

    // Default campagin is full campagin
    this.campaignType = this.editdata.campaign_type ? this.editdata.campaign_type : 'full'
    this.campaign_id = this.editdata.campaign_id ? this.editdata.campaign_id : 0

    if (this.editdata.store_id) {
      this.input.store_id = this.editdata.store_id
      var store = this.$store.state.toaEcouponStore
      var currentStore = store.find((el) => el.store_id == this.input.store_id)
      this.input.store_name = currentStore.store_name
      this.input.store = currentStore.store_name
    }

    this.input.ref_no = this.editdata.ref_receipt
    this.input.date = moment(this.editdata.timestamp).format('YYYY-MM-DD')
    if (this.editdata.detail) {
      this.products = this.editdata.detail.products
      this.coupon = this.editdata.detail.coupon
      if (this.editdata.detail.date) {
        this.input.date = this.editdata.detail.date
      }

      if (this.editdata.detail.hasOwnProperty('include_vat')) {
        this.includeVat = this.editdata.detail.include_vat
      }

      this.discount = this.editdata.detail.discount ? this.editdata.detail.discount : 0
    }
  },
  methods: {
    onSearchProduct(query) {
      this.searchProduct = query
    },
    changePrice(item) {
      if (!item.total || !item.quantity) this.$set(item, 'price', 0)
      else this.$set(item, 'price', parseInt((item.total / item.quantity) * 100) / 100)
    },
    showImage(item, images, k) {
      var items = images.map((el, index) => {
        return {
          src: el,
          title: `${index + 1}/${images.length}`
        }
      })

      // define options (if needed)
      var options = {
        fixedContent: false,
        fixedModalPos: true,
        index: k // this option means you will start at first image
      }

      // Initialize the plugin
      var viewer = new PhotoViewer(items, options)
      document.querySelector('.photoviewer-modal').addEventListener(
        'click',
        function (event) {
          //  document.getElementById("output-box").innerHTML += "Sorry! <code>preventDefault()</code> won't let you check this!<br>";
          event.preventDefault()
        },
        false
      )
    },
    async checkAvailableRef() {
      let data = {
        body: {
          refReceipt: this.input.ref_no,
          storeId: this.input.store_id,
          campaignId: this.campaign_id,
          ref_date: this.input.date
        }
      }
      this.checkRefLoading = true
      let response = await api.checkDuplicateBillToaecoupon(data)
      this.checkRefLoading = false
      if (!response.data.IsUsed) {
        this.isRefnoValid = true
      } else {
        this.duplicateReceiptId = response.data.ref.id
        this.isRefnoValid = false
        let result = await this.$swal.fire({
          icon: 'error',
          text: 'เลขที่ใบเสร็จนี้ ถูกใช้แล้ว',
          showCancelButton: true,
          cancelButtonText: 'ปิด',
          confirmButtonText: 'ดู'
        })

        if (result.value) {
          // emit to parent
          // searn receipt by id and open this component again
          // Cancel this then open new tab instead
          //this.$emit('onviewreceipt', this.duplicateReceiptId)

          let url = `${window.location.protocol}//${window.location.hostname}${
            window.location.port ? ':' + window.location.port : ''
          }/`

          window.open(
            url + 'th/template?view=approveReceipt&transactionId=' + this.duplicateReceiptId,
            '_blank'
          )
        }
      }
    },
    async saveData() {
      if (await this.$validator.validateAll()) {
        this.saveloading = true
        await this.save()
      }
    },
    async save() {
      return new Promise((resolve) => {
        let products = _.cloneDeep(this.products)
        products = products ? products.filter((el) => el.name != '' && el.name != null) : []

        if (this.approvetype != 'reject' && products.length == 0) {
          this.saveloading = false
          this.$swal.fire('ไม่สามารถดำเนินการได้', 'กรุณาใส่ข้อมูลสินค้า', 'error')
          resolve()
          return
        }

        var data = {
          pageid: this.selectedBot.pageid,
          store_name: this.input.store_name,
          store_id: this.input.store_id,
          ref_receipt: this.input.ref_no,
          ref_date: this.input.date,
          detail: {
            ref_no: this.input.ref_no,
            ref: this.input.ref,
            date: this.input.date,
            products: products,
            coupon: this.coupon,
            include_vat: this.includeVat,
            discount: this.discount ? this.discount : 0
          },
          id: this.editdata.id,
          adminId: this.$store.state.userid,
          campaign_type: this.campaignType,
          campaign_id: this.campaign_id,
          sell_score: this.campaignType == 'collect' ? this.sumScoreCollect : 0,
          special_score: this.campaignType == 'collect' ? this.sumSpacialPrice : 0,
          score: this.campaignType == 'collect' ? this.sumAllCollectScore : 0,
          total_privilege: this.campaignType == 'lucky_draw' ? this.sumPrivilege : 0
        }

        if (this.approvetype == 'approved' && this.campaignType == 'full') {
          if (this.coupon.length == 0) {
            this.saveloading = false
            this.$swal.fire('ไม่สามารถดำเนินการได้', 'กรุณาใส่คูปอง', 'error')
            resolve()
            return
          }
          Object.assign(data, {
            status: this.approvetype,
            ecoupon: this.coupon,
            reject_reason: ''
          })
        } else if (this.approvetype == 'reject') {
          Object.assign(data, {
            status: this.approvetype,
            ecoupon: [],
            reject_reason:
              this.rejectReason == 'อื่น ๆ โปรดระบุ..' ? this.input.remark : this.rejectReason
          })
        } else {
          Object.assign(data, {
            status: this.approvetype,
            ecoupon: [],
            reject_reason: ''
          })
        }

        api.updateCouponToaecoupon(data, async (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            await this.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            this.$emit('onsave')
          }
          resolve()
        })
      })
    },
    customProductsName(val) {
      return val.product_name_th
    },
    deleteProducts(k) {
      this.products.splice(k, 1)
      this.errors.clear()
    },
    copyProducts(item) {
      let new_item = _.cloneDeep(item)
      this.products.push(new_item)
      this.errors.clear()
    },
    addmoreproduct() {
      this.products.push({
        name: '',
        price: 0,
        quantity: 1,
        total: 0,
        score: 0
      })
      this.$nextTick(() => {
        const productRef = this.$refs['productInput' + (this.products.length - 1)]
        productRef[0].$el.focus()
      })
    },
    addmorecoupon() {
      this.coupon.push({
        barcode: '',
        amount: ''
      })
    },
    deleteCoupon(k) {
      this.coupon.splice(k, 1)
      this.errors.clear()
    },
    onChangeProduct(k, e) {
      // this.products[k].price = e.price || 0
      this.products[k].price = 0
      this.products[k].total = 0
      this.products[k].quantity = 0
      this.products[k].score = e.score || 0
    },
    onSelectedStore(selectStore) {
      var store = this.$store.state.toaEcouponStore
      var currentStore = store.filter((el) => {
        return el.store_name == selectStore
      })
      this.input.store_id = currentStore[0].store_id
      this.input.store_name = currentStore[0].store_name
    },
    getDate(val) {
      if (val) return moment(val).format('DD/MM/YYYY')
      else return ''
    },
    customMaterialName(val) {
      return `${val.product_name_en} ${val.product_name_th} (${val.product_size})`
    }
  }
}
</script>

<style lang="scss">
.showcarouselall div span {
  /* Your style */
  display: block !important;
}
.toa-product .multiselect__content-wrapper /*, .multiselect__element */ {
  width: fit-content;
}

.toa-product .multiselect__input {
  margin-top: 0 !important;
}

.toa-product .multiselect__element {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ApproveReceiptEdit.vue